import { useQuery } from "@tanstack/react-query";
import drEasyApi from "../Api/Customapi"

const fetchCenterById=async(centerId)=>{

    try{
      const res=await drEasyApi.get("/api/Centers/Get",{params:{centerId:centerId}})
      return res.data
    }catch(err){

    }
}


export const useGetCenterById=(centerId)=>{
    return useQuery({
        queryFn:()=>fetchCenterById(centerId),
        queryKey:["centerById"],
        enabled:!!centerId
    })  
}